<template>
  <Dialog
    v-model="dialog"
    width="800"
    title-left
    :title="documentContent && documentContent.title ? documentContent.title : null"
    :loading="loadingLegalDocuments || !documentContent || !documentContent.content"
  >
    <template #text>
      <div class="legal-document" v-html="documentContent.content" />
    </template>
  </Dialog>
</template>

<script>
import legalDocuments from '@/mixins/legalDocuments';
import Dialog from '@/components/Atoms/Dialog';

export default {
  name: 'DocumentModal',
  components: { Dialog },
  mixins: [legalDocuments],
  props: {
    name: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    typeName: {
      type: String,
      required: true
    },
    identifier: {
      type: [String, Number],
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      documentContent: {
        content: ''
      }
    };
  },
  watch: {
    async dialog(newValue) {
      if (newValue) {
        this.documentContent = (await this.getLegalDocument(this.category, this.typeName)) ?? {
          content: ''
        };
      }
    }
  },
  created() {
    this.$eventHub.$on(
      `open${this.name[0].toUpperCase()}${this.name.slice(1)}Modal${
        this.identifier ? `_${this.identifier}` : ''
      }`,
      () => {
        this.dialog = true;
      }
    );
  },
  beforeDestroy() {
    this.$eventHub.$off(
      `open${this.name[0].toUpperCase()}${this.name.slice(1)}Modal${
        this.identifier ? `_${this.identifier}` : ''
      }`
    );
  }
};
</script>
